<ng-container *ngIf="departmentAccess$ | async as departmentAccess">
  <div
    class="job-requests-header"
    data-cy="job-requests-header">
    <h1
      class="availability-edit-title"
      *ngIf="!(tabs$ | async)?.length">
      {{ ("wardManagement" | i18n) || "Mitarbeiterpool" | titlecase }}
    </h1>
    <div class="tabs aligned-start condensed">
      <nav
        mat-tab-nav-bar
        class="themed-tab-nav">
        <a
          mat-tab-link
          *ngFor="let tab of tabs$ | async"
          (click)="switchTab(tab.value)"
          [active]="(activeTabId$ | async) == tab.value"
          [attr.data-cy]="
            'tab-' +
            tab.value +
            '-' +
            ((activeTabId$ | async) == tab.value ? 'active' : 'inactive')
          ">
          <mat-icon
            *ngIf="tab.svgIcon"
            [svgIcon]="tab.svgIcon"
            class="size-20"></mat-icon>
          {{ tab.label | i18n | titlecase }}
        </a>
      </nav>
    </div>
    <div class="filter-actions">
      <button
        mat-stroked-button
        class="filter-button"
        [class.collapsed]="filtersCollapsed$ | async"
        (click)="toggleFilters()"
        data-cy="job-requests-collapse-filter-button"
        type="button">
        <div class="filter-button-content">
          <mat-icon svgIcon="filter_alt_outline"></mat-icon>
          <span class="mat-fab__label">{{
            ("filter" | i18n) || "Filter"
          }}</span>
          <span
            *ngIf="((filterCounts$ | async) || 0) > 0"
            class="badge"
            data-cy="count-badge">
            {{ filterCounts$ | async }}
          </span>
          <span
            *ngIf="(filterCounts$ | async) === 0"
            class="inverse-badge"
            data-cy="inverse-badge">
            -
          </span>
        </div>
      </button>

      <app-tab-toggle
        (click)="toggleView()"
        class="jobs-view-toggle">
        <app-tab-toggle-option
          [active]="(activeView$ | async) === 'tiles'"
          data-cy="jobs-view-toggle-tiles">
          <mat-icon
            svgIcon="tiles"
            size="20"
            class="toggle-icon"></mat-icon>
          {{ ("tiles" | i18n) || "Kacheln" }}
        </app-tab-toggle-option>
        <app-tab-toggle-option
          [active]="(activeView$ | async) === 'list'"
          data-cy="jobs-view-toggle-list">
          <mat-icon
            svgIcon="jobs-list"
            size="20"
            class="toggle-icon"></mat-icon>
          {{ ("list" | i18n) || "Liste" }}
        </app-tab-toggle-option>
      </app-tab-toggle>
    </div>
  </div>

  <ng-container *ngIf="(activeTabId$ | async) === JobRequestTabId.REQUEST">
    <div class="row">
      <div class="col">
        <app-department-select
          [autoSelectOnlyDepartment]="true"
          [useQueryParam]="'departmentId'"
          [required]="true"
          [attr.data-cy]="
            'job-request-department-select'
          "></app-department-select>
      </div>
    </div>
  </ng-container>

  <div
    class="collapse-wrapper collapse-filter"
    [class.collapsed]="filtersCollapsed$ | async"
    [class.expanded]="!(filtersCollapsed$ | async)">
    <div class="collapse-child">
      <div class="row filter-bar">
        <div class="col-md-4">
          <app-job-type-multiselect
            [useQueryParam]="'jobType'"
            [lightFormField]="true"
            data-cy="job-type-filter">
          </app-job-type-multiselect>
        </div>
        <div class="col-md-4">
          <app-shift-select
            [useQueryParam]="'shift'"
            [label]="('shift' | i18n) || 'Schicht'"
            data-cy="shift-filter">
          </app-shift-select>
        </div>
        <div class="col-md-4">
          <app-demand-reason-select
            [useQueryParam]="'demandReason'"
            [lightFormField]="true"
            data-cy="demand-reason-filter">
          </app-demand-reason-select>
        </div>
      </div>
      <div
        class="save-filter-row"
        *ngIf="!(disableFilterSave$ | async)">
        <button
          mat-button
          class="save-filter-button"
          (click)="saveJobRequestFilters()"
          data-cy="save-filter-button">
          <div class="filter-actions-button-content">
            <mat-icon
              svgIcon="save"
              size></mat-icon>
            {{ ("saveDefaultFilter" | i18n) || "Filter speichern" }}
          </div>
        </button>
      </div>
    </div>
  </div>
  <ng-container *ngIf="dataReady$ | async; else loading">
    <ng-container
      *ngIf="
        (activeTabId$ | async) === JobRequestTabId.REQUEST;
        else approveTab
      ">
      <ng-container
        *ngIf="
          departmentQueryParams$ | async as activeDepartmentId;
          else noActiveDepartment
        ">
        <div
          class="jobs-list"
          *ngIf="(activeView$ | async) === 'list'; else tilesView">
          <div
            *ngIf="months?.length"
            class="jobs-index-sideline-container"
            [class.is-compact]="(activeView$ | async) === 'list'">
            <div class="jobs-index-sideline-start"></div>
            <div class="jobs-index-sideline"></div>
            <div class="jobs-index-sideline-end"></div>
          </div>
          <div
            class="jobs-index-jobs-list list-view"
            data-cy="job-requests-list-view">
            <div class="jobs-list-view-header-row">
              <div
                *ngFor="
                  let column of columns$ | async;
                  trackBy: trackByColumnKey
                "
                class="job-list-view-header-column"
                [attr.data-column-key]="column.key"
                [class.with-small-spacing]="column.smallSpacing">
                <span>{{ (column.key | i18n) || column.label }}</span>
                <div
                  class="column-resize-handle"
                  (mousedown)="onResizeStart($event, column.key)"></div>
              </div>
            </div>
            <div class="jobs-list-view-header-row-bar"></div>
            <ng-container
              *ngFor="
                let month of months;
                let i = index;
                trackBy: trackByMonth
              ">
              <ng-container
                *ngFor="let week of month?.weeks; trackBy: trackByWeek">
                <div
                  *ngIf="(week.dates[0] | date: 'cc') === '1' || month?.weeks?.[0] == week"
                  class="jobs-index-previous-date-range">
                  <div>
                    {{ ("calendarWeekShort" | i18n) || "KW" }}
                    {{ week.dates[0] | date: "ww" }} /
                    {{ week.dates[0] | date: "dd.MM.yyyy" }} -
                    {{ week.dates[week.dates.length - 1] | date: "dd.MM.yyyy" }}
                  </div>
                </div>
                <ng-container *ngFor="let date of week?.dates">
                  <div
                    class="jobs-index-day-header"
                    *ngIf="date | date: 'cc' as dayOfTheWeek"
                    [attr.data-cy]="'care-management-day-' + date">
                    <div class="day-start-circle"></div>
                    <div>
                      <span class="day-of-the-week">{{
                        date | date: "EEE"
                      }}</span>
                      {{ date | date: "dd.MM.yyyy" }}
                      <span class="calendar-week">
                        {{ ("calendarWeekShort" | i18n) || "KW" }}
                        {{ date | date: "ww" }}
                      </span>
                    </div>
                    <div
                      *ngIf="departmentAccess?.writeAll || departmentAccess?.specificDepartmentIds?.[activeDepartmentId]?.write"
                      class="shift-selection">
                      <div class="shift-selection-title">
                        {{ ("requestShift" | i18n) || "Schicht anfragen" }}
                      </div>
                      <ng-container
                        *ngFor="
                          let shiftGroup of shiftsOfDepartment[dayOfTheWeek];
                          trackBy: trackByShiftGroup
                        ">
                        <div
                          class="custom-chip"
                          [matMenuTriggerFor]="shiftMenu"
                          *ngIf="shiftGroup.shifts.length === 1"
                          (click)="
                            createJobRequest(
                              date,
                              shiftGroup.shifts[0],
                              activeDepartmentId
                            )
                          "
                          [attr.data-cy]="
                            'new-job-request-button' +
                            '-' +
                            date +
                            '-' +
                            shiftGroup.shift
                          ">
                          {{
                            ("shifts." + shiftGroup.shift | i18n) ||
                              shiftEnum[shiftGroup.shift] | titlecase
                          }}
                        </div>
                        <div
                          class="custom-chip"
                          [matMenuTriggerFor]="shiftMenu"
                          *ngIf="shiftGroup.shifts.length > 1"
                          [attr.data-cy]="
                            'new-job-request-button' +
                            '-' +
                            date +
                            '-' +
                            shiftGroup.shift
                          ">
                          {{
                            ("shifts." + shiftGroup.shift | i18n) ||
                              shiftEnum[shiftGroup.shift] | titlecase
                          }}
                        </div>
                        <mat-menu #shiftMenu="matMenu">
                          <button
                            mat-menu-item
                            *ngFor="
                              let shift of shiftGroup.shifts;
                              trackBy: trackByShift
                            "
                            (click)="
                              createJobRequest(date, shift, activeDepartmentId)
                            "
                            [attr.data-cy]="
                              'shift-selection-menu-item-' + shift.id
                            ">
                            {{
                              shift.label ||
                                ("shifts." + shift.shift | i18n) ||
                                shiftEnum[shift.shift] | titlecase
                            }}
                            <span class="shift-time"
                              >{{ shift.from | time }} -
                              {{ shift.to | time }}</span
                            >
                          </button>
                        </mat-menu>
                      </ng-container>
                    </div>
                  </div>
                  <div
                    class="jobs-index-jobs-list-items"
                    *ngIf="jobRequestsByDate$ | async as jobRequestsByDate">
                    <ng-container
                      *ngFor="let jobRequest of jobRequestsByDate[date]">
                      <app-job-request-item
                        [jobRequest]="jobRequest"
                        [showJobDate]="false"
                        [readOnly]="(!departmentAccess.writeAll && !departmentAccess?.specificDepartmentIds?.[activeDepartmentId]?.write) || !jobRequest.requestedAt"
                        [compact]="true"
                        [columns]="(columns$ | async) || []"
                        [attr.data-cy]="
                          'job-request-item-' + jobRequest._id
                        "></app-job-request-item>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <ng-template #tilesView>
          <app-accordion
            *ngFor="let month of months; let i = index; trackBy: trackByMonth"
            class="care-management-month"
            [collapsed]="month.collapsed"
            (accordionToggled)="month.collapsed = $event">
            <app-accordion-header
              [collapseOnHeaderClick]="true"
              [displayArrowButton]="false"
              class="care-management-month-date">
              <div>{{ month?.startDate | date: "MMMM" }}</div>

              <mat-icon
                class="collapse-toggle"
                [class.rotate]="month.collapsed"
                svgIcon="chevron-down"></mat-icon>
            </app-accordion-header>
            <app-accordion-content
              class="multiDay-accordion-content"
              #accordionContent>
              <div class="care-management-month-inside">
                <div class="care-management-month-sideline"></div>
                <div
                  *ngFor="let week of month?.weeks; trackBy: trackByWeek"
                  class="availability-week-item__week-wrapper">
                  <div
                    *ngIf="(week.dates[0] | date: 'cc') === '1' || month?.weeks?.[0] == week"
                    class="care-management-week-separator">
                    {{ ("calendarWeekShort" | i18n) || "KW" }}
                    {{ week.dates[0] | date: "ww" }} /
                    {{ week.dates[0] | date: "dd.MM.yyyy" }} -
                    {{ week.dates[week.dates.length - 1] | date: "dd.MM.yyyy" }}
                  </div>
                  <div
                    *ngFor="let date of week?.dates"
                    class="care-management-day"
                    [attr.data-cy]="'care-management-day-' + date"
                    [class.first-of-week]="(date | date: 'cc') === '1'">
                    <div
                      class="care-management-day-header"
                      *ngIf="date | date: 'cc' as dayOfTheWeek">
                      <div class="care-management-day-start-circle"></div>
                      <div>
                        <span class="day-of-the-week">{{
                          date | date: "EEE"
                        }}</span>
                        {{ date | date: "dd.MM.yyyy" }}
                      </div>
                      <div
                        *ngIf="departmentAccess?.writeAll || departmentAccess?.specificDepartmentIds?.[activeDepartmentId]?.write"
                        class="shift-selection">
                        <div class="shift-selection-title">
                          {{ ("requestShift" | i18n) || "Schicht anfragen" }}
                        </div>
                        <ng-container
                          *ngFor="
                            let shiftGroup of shiftsOfDepartment[dayOfTheWeek];
                            trackBy: trackByShiftGroup
                          ">
                          <div
                            class="custom-chip"
                            [matMenuTriggerFor]="shiftMenu"
                            *ngIf="shiftGroup.shifts.length === 1"
                            (click)="
                              createJobRequest(
                                date,
                                shiftGroup.shifts[0],
                                activeDepartmentId
                              )
                            "
                            [attr.data-cy]="
                              'new-job-request-button' +
                              '-' +
                              date +
                              '-' +
                              shiftGroup.shift
                            ">
                            {{
                              ("shifts." + shiftGroup.shift | i18n) ||
                                shiftEnum[shiftGroup.shift] | titlecase
                            }}
                          </div>
                          <div
                            class="custom-chip"
                            [matMenuTriggerFor]="shiftMenu"
                            *ngIf="shiftGroup.shifts.length > 1"
                            [attr.data-cy]="
                              'new-job-request-button' +
                              '-' +
                              date +
                              '-' +
                              shiftGroup.shift
                            ">
                            {{
                              ("shifts." + shiftGroup.shift | i18n) ||
                                shiftEnum[shiftGroup.shift] | titlecase
                            }}
                          </div>
                          <mat-menu #shiftMenu="matMenu">
                            <button
                              mat-menu-item
                              *ngFor="
                                let shift of shiftGroup.shifts;
                                trackBy: trackByShift
                              "
                              (click)="
                                createJobRequest(
                                  date,
                                  shift,
                                  activeDepartmentId
                                )
                              "
                              [attr.data-cy]="
                                'shift-selection-menu-item-' + shift.id
                              ">
                              {{
                                shift.label ||
                                  ("shifts." + shift.shift | i18n) ||
                                  shiftEnum[shift.shift] | titlecase
                              }}
                              <span class="shift-time"
                                >{{ shift.from | time }} -
                                {{ shift.to | time }}</span
                              >
                            </button>
                          </mat-menu>
                        </ng-container>
                      </div>
                    </div>
                    <div class="job-request-list">
                      <ng-container
                        *ngIf="jobRequestsByDate$ | async as jobRequestsByDate">
                        <ng-container
                          *ngFor="
                            let jobRequest of jobRequestsByDate[date];
                            trackBy: trackByJobRequest
                          ">
                          <app-job-request-item
                            [jobRequest]="jobRequest"
                            [showJobDate]="false"
                            [readOnly]="(!departmentAccess.writeAll && !departmentAccess?.specificDepartmentIds?.[activeDepartmentId]?.write) || !jobRequest.requestedAt"
                            [attr.data-cy]="
                              'job-request-item-' + jobRequest._id
                            "></app-job-request-item>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </app-accordion-content>
          </app-accordion>
        </ng-template>
      </ng-container>

      <ng-template #noActiveDepartment>
        {{
          ("noActiveDepartment" | i18n) || "Bitte wählen Sie eine Abteilung aus"
        }}
      </ng-template>
    </ng-container>
  </ng-container>
  <ng-template #approveTab>
    <div
      *ngIf="(activeView$ | async) === 'list'; else approveTilesView"
      class="jobs-list">
      <div
        class="jobs-index-jobs-list list-view"
        data-cy="job-requests-approve-list-view">
        <div class="jobs-list-view-header-row">
          <div
            *ngFor="let column of columns$ | async; trackBy: trackByColumnKey"
            class="job-list-view-header-column"
            [attr.data-column-key]="column.key"
            [class.with-small-spacing]="column.smallSpacing">
            <span>{{ (column.key | i18n) || column.label }}</span>
            <div
              class="column-resize-handle"
              (mousedown)="onResizeStart($event, column.key)"></div>
          </div>
        </div>
        <div class="jobs-list-view-header-row-bar"></div>
        <div class="jobs-index-jobs-list-items">
          <ng-container
            *ngIf="(openJobRequests$ | async)?.length; else noJobRequests">
            <div
              *ngFor="
                let jobRequest of openJobRequests$ | async;
                trackBy: trackByJobRequest
              ">
              <app-job-request-item
                [jobRequest]="jobRequest"
                [showJobDate]="true"
                [showDepartment]="true"
                [compact]="true"
                [columns]="(columns$ | async) || []"
                [attr.data-cy]="
                  'job-request-item-' + jobRequest._id
                "></app-job-request-item>
            </div>
          </ng-container>
          <ng-template #noJobRequests>
            <div
              class="no-job-requests"
              *ngIf="!(jobRequestsLoading$ | async); else loading">
              {{ "noOpenJobRequests" | i18n }}
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <ng-template #approveTilesView>
      <div class="job-requests-list">
        <ng-container
          *ngIf="(openJobRequests$ | async)?.length; else noJobRequests">
          <div
            *ngFor="
              let jobRequest of openJobRequests$ | async;
              trackBy: trackByJobRequest
            ">
            <app-job-request-item
              [jobRequest]="jobRequest"
              [showJobDate]="true"
              [showDepartment]="true"
              [attr.data-cy]="
                'job-request-item-' + jobRequest._id
              "></app-job-request-item>
          </div>
        </ng-container>
        <ng-template #noJobRequests>
          <div
            class="no-job-requests"
            *ngIf="!(jobRequestsLoading$ | async); else loading">
            {{ "noOpenJobRequests" | i18n }}
          </div>
        </ng-template>
      </div>
    </ng-template>
  </ng-template>
</ng-container>
<ng-template #loading>
  <mat-spinner
    diameter="24"
    data-cy="job-requests-loading-spinner"></mat-spinner>
</ng-template>
